module.exports = __webpack_public_path__ + "img/cash-blue.c2723431.svg";